<template>
    <div id="app">
        <keep-alive>
            <router-view class="app-box" :isMobile="isMobile" :cdnPrefix="cdnPrefix" />
        </keep-alive>

        <div v-show="show_maker" @click="toTop" class="marker">
            <img src="@/assets/imgs/marker.png" alt />
        </div>
    </div>
</template>

<script>
export default {
    name: "App",
    components: {},
    data() {
        return {
            isMobile: document.body.offsetWidth <= 768 ? true : false,
            show_maker: false,
            cdnPrefix: "https://cdn-cn-web.bekko.com/gw/games/zgbw/assets",
        };
    },
    watch: {
        $route(to, from) {
            this.$nextTick(() => {
                document.querySelector(".app-box").scrollTo(0, 0);
            });
        }
    },
    mounted() {
        localStorage.setItem("appid", "2002");

        this.htmlBasicsSetting();

        this.handleDefault();

        // 追踪链接
        this.handleTrace();
    },
    methods: {
        // 基础设置
        htmlBasicsSetting() {
            // 页面基础字体
            let winW = document.documentElement.clientWidth,
                desW = 1900,
                htmlFont = (winW / desW) * 14;
            if (winW > 768) {
                window.htmlFont = htmlFont;
                document.documentElement.style.fontSize = htmlFont + "px";
            } else {
                document.documentElement.style.fontSize = "14px";
            }
        },
        handleDefault() {
            setTimeout(() => {
                let appBox = document.querySelector(".app-box");
                if (appBox) {
                    // console.log("appBox 加载完毕");
                    appBox.scrollTo(0, 0);
                    appBox.onscroll = this.handleOnScroll;
                    appBox.onresize = this.handleOnResize;
                } else {
                    // console.log("appBox 尚未加载");
                    this.handleDefault();
                }
            }, 100);
        },
        // 追踪链接
        handleTrace() {
            let webname = this.GetUrlParam("trace");
            if (webname) {
                let clickFreq = sessionStorage.getItem("jedi_p20n");
                if (!clickFreq) {
                    this.getClickFreq(webname);
                }
                sessionStorage.setItem("jedi_p20n", webname);
            }
        },
        getClickFreq(webname) {
            $.ajax({
                url: "./api/data.php",
                type: "post",
                async: true,
                data: {
                    func: "getClickFreq",
                    webname: webname
                },
                success: function(data, status) {}
            });
        },
        GetUrlParam(paraName) {
            let url = document.location.toString(),
                arrObj = url.split("?");

            if (arrObj.length > 1) {
                let arrPara = arrObj[1].split("&");
                let arr;
                for (let i = 0; i < arrPara.length; i++) {
                    arr = arrPara[i].split("=");

                    if (arr != null && arr[0] == paraName) {
                        return arr[1];
                    }
                }
                return "";
            } else {
                return "";
            }
        },
        handleOnScroll(e) {
            let scrollTop = document.querySelector(".app-box").scrollTop;
            // console.log(scrollTop);
            this.show_maker = scrollTop >= 200 ? true : false;
        },
        handleOnResize(e) {
            this.isMobile = document.body.offsetWidth <= 768 ? true : false;
        },
        toTop() {
            document.querySelector(".app-box").scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }
};
</script>

<style lang="scss">
@keyframes animate_bounce_maker {
    0% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(20px);
    }
    100% {
        transform: translateY(0px);
    }
}
#app {
    height: 100%;
    .marker {
        z-index: 1000;
        cursor: pointer;
        position: fixed;
        bottom: 20px;
        right: 5%;
        width: 50px;
        animation: "animate_bounce_maker" 1s ease-in-out infinite;
    }
}
// 移动端
@media screen and (max-width: 768px) {
    #app {
        .marker {
            display: none;
        }
    }
}

html,
body {
    height: 100%;
}
ul li {
    list-style: none;
}
a {
    text-decoration: none;
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}
.hide {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue